// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  // apiUrl: "http://localhost:3692/InvoiceAPI/api",
  // imageUrl: 'http://localhost:3692/'
  apiUrl: "http://10.10.10.30:93/server/InvoiceAPI/api",
  imageUrl: 'http://10.10.10.30:93/server'
};




// WEBPACK FOOTER //
// ./src/environments/environment.ts